export const defaultLanguage = "en";
export const fallbackLanguage = "en";
export const supportedLanguages = ["en", "pl"] as const;
export type SupportedLanguage = (typeof supportedLanguages)[number];
// Not translated on purpose: each language is named in itself, so someone who
// landed in the wrong one still recognises their own in the picker.
export const languageNames: Record<SupportedLanguage, string> = {
  en: "English",
  pl: "Polski",
};
export const defaultNameSpace = "";
export const namespaces = ["common"] as const;
